const DOCUMENT = 'POSITION_ACCREDITATION_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  DELETE_ACCREDITATION_REQUEST: DOCUMENT + 'DELETE_REQUEST',
  DELETE_ACCREDITATION_SUCCESS: DOCUMENT + 'DELETE_SUCCESS',

  loadData: data => ({ type: actions.LOAD, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  removeAccreditation: data => ({ type: actions.DELETE_ACCREDITATION_REQUEST, payload: data }),
  removeAccreditationSuccess: data => ({ type: actions.DELETE_ACCREDITATION_SUCCESS, payload: data }),
};

export default actions;
